import React from 'react';
import {Droppable} from 'react-beautiful-dnd';

const DropZone = (props: any): React.ReactElement => {
  const {children} = props;

  return (
    <Droppable droppableId="widgetList">
      {provided => (
        <div ref={provided.innerRef} {...provided.droppableProps}>
          {children}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DropZone;
